import { Guid, IBaseModel, Money } from '@/interfaces/base'
import { SalaryPeriod } from './salary-period'
import { Workshop } from './workshop'
import { Personnel } from './personnel'
import { JobGroup } from './job-group'
import { JobField } from './job-field'
import { ContractTypes, InsuranceTypes, InsuranceBaseTypes, PersonnelEducationalStatusTypes, PersonnelEmploymentAsTypes, PersonnelEmploymentTypes, PersonnelMarriageTypes, PersonnelMilitaryStatusTypes, PersonnelSacrificeStatusTypes, DocumentFloatingCenterSelectionTypes } from '@/enums/salary'
import emptyId from '@/statics/empty-id'
import { ContractSalaryItem } from './contract-salary-item'
import { CooperateType } from '@/classes/salary/cooperate-type'
import { JobCode } from './job-code'
import { WorkPlaceStatus } from './workplace-status'
import { TaxCalculationTableHeader } from './tax-calculation-table'
import { Position } from './position'
import { FloatingCenter } from '../system/floating-center'

export class Contract implements IBaseModel {
  id: Guid
  salaryPeriodId: Guid
  number!: number
  workshopId: Guid
  PersonnelId: Guid
  calculated: boolean
  position!: Position
  marriage: PersonnelMarriageTypes
  childrenCount!: number
  militaryStatus!: PersonnelMilitaryStatusTypes
  sacrificeStatus!: PersonnelSacrificeStatusTypes
  educationalStatus: PersonnelEducationalStatusTypes
  educationalField!: string
  documentFloatingCenterSelectionType!: DocumentFloatingCenterSelectionTypes
  insuranceType!: InsuranceTypes
  insuranceBaseType!: InsuranceBaseTypes
  insuranceNumber!: string
  jobCode: JobCode | null
  insuranceStartDate!: Date | null
  insuranceLeaveDate!: Date | null
  insuranceIncludeHardJob: boolean
  exportableInInsuranceDisket!: boolean
  workplaceStatus: WorkPlaceStatus | null
  taxFreeAmount: Money
  taxFreePercentage: number
  taxStartDate?: Date | null
  taxEndDate!: Date | null
  cooperateType!: CooperateType
  exportableInTaxDisket: boolean
  jobGroupId!: Guid
  baseOfDailyYears: Money | number
  yearsOfExperience: number
  severancesGroup: number
  employmentAs!: PersonnelEmploymentAsTypes
  dailyFee: Money | number
  employmentType!: PersonnelEmploymentTypes
  contractType!: ContractTypes
  jobFieldId!: Guid
  jobCodeInMinistry!: string
  workingPlace!: string
  date!: Date | null
  startDate!: Date | null
  endDate!: Date | null
  descriptionRelatedToSalaryItems!: string
  insurancableSum!: Money
  taxableSum!: Money
  insurance!: Money
  tax!: Money
  incrementalSum!: Money
  decrementalSum!: Money
  payable!: Money
  isLock: boolean
  salaryPeriod!: SalaryPeriod
  workshop!: Workshop
  personnel!: Personnel
  jobGroup!: JobGroup | null
  jobField!: JobField
  contractSalaryItems!: ContractSalaryItem[] // type may change to ContractSalaryItem
  taxCalculationTableHeader: TaxCalculationTableHeader | null
  contractMetaData!: ContractMetaData
  workingPlaceFloatingCenter: FloatingCenter | null
  workshopFloatingCenter: FloatingCenter | null

  constructor() {
    this.id = emptyId
    this.salaryPeriodId = ''
    this.workshopId = emptyId
    this.PersonnelId = emptyId
    this.calculated = false
    this.marriage = PersonnelMarriageTypes.Single
    this.educationalStatus = PersonnelEducationalStatusTypes.Bachelors
    this.sacrificeStatus = PersonnelSacrificeStatusTypes.NotHaving
    this.jobCode = new JobCode()
    this.workplaceStatus = new WorkPlaceStatus()
    this.insuranceIncludeHardJob = false
    this.exportableInTaxDisket = false
    this.taxFreeAmount = '0'
    this.taxFreePercentage = 0
    this.exportableInTaxDisket = false
    this.dailyFee = 0
    this.baseOfDailyYears = 0
    this.yearsOfExperience = 0
    this.severancesGroup = 0
    this.insuranceStartDate = null
    this.insuranceLeaveDate = null
    this.taxStartDate = null
    this.taxEndDate = null
    this.startDate = null
    this.endDate = null
    this.employmentAs = PersonnelEmploymentAsTypes.Daily
    this.employmentType = PersonnelEmploymentTypes.Other
    this.documentFloatingCenterSelectionType = DocumentFloatingCenterSelectionTypes.Workshop
    this.workingPlaceFloatingCenter = null
    this.workshopFloatingCenter = null
    this.jobCode = null
    this.jobGroup = null
    this.workplaceStatus = null
    this.taxCalculationTableHeader = null
    this.isLock = false
  }
}

export class ContractMetaData {
  sumReducingSalaryItems!: number
  freeTaxWorkshop!: number
  taxPrimitive!: number
  sumPresentAmount!: number
  sumUnEmploymentInsurance!: number
  sumEmployerInsurance!: number
  sumMonthlyWage!: number
  sumWorkingDays!: number
  overtimeSalary!: number
  cashAndContinuous!: number
  cashAndContinuousNotTaxable!: number
  notCashAndContinuous!: number
  cashAndNotContinuous!: number
  cashAndNotContinuousWithoutTaxable!: number
  notCashAndNotContinuous!: number
  sumReducingTaxSalaryItems!: number
  presentTax!: number
  oldInsurable!: number
}